import { IStage } from '@forwardflow/store'
import { useDraggable } from '@dnd-kit/core'
import cn from 'classnames'

interface DnDStageAndTagPillProps {
   stage: IStage
   onClose?: (stageId: string) => void
   isSelected?: boolean
   isSuggestionPill?: boolean
}

export const DnDStageAndTagPill = ({
   stage,
   onClose,
   isSelected = false,
   isSuggestionPill,
}: DnDStageAndTagPillProps) => {
   const { attributes, listeners, setNodeRef, transform, isDragging } =
      useDraggable({
         id: stage.id,
         data: stage,
      })

   const style = transform
      ? {
           transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
           opacity: isDragging ? 0.5 : 1,
        }
      : undefined

   const handleClose = (e: React.MouseEvent) => {
      e.preventDefault()
      e.stopPropagation()
      onClose?.(stage.id)
   }

   return (
      <div
         ref={setNodeRef}
         style={style}
         className={cn(
            'rounded-[8px] shadow-[0_4px_4px_0_rgba(0,0,0,0.25)] py-1.5 px-8 text-sm w-fit relative group',
            {
               'bg-white/20': !isSuggestionPill,
               'bg-primary text-white': isSuggestionPill,
               'shadow-none': isSelected,
            }
         )}
      >
         <p
            {...listeners}
            {...attributes}
            className="cursor-grab active:cursor-grabbing"
         >
            {stage.name}
         </p>
         {onClose && (
            <button
               onClick={handleClose}
               className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 hover:bg-red-600 rounded-full flex items-center justify-center text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer z-10"
               type="button"
            >
               ×
            </button>
         )}
      </div>
   )
}
